import ipfs from 'decentralized/Ipfs.js';
import StepData from 'pattern/StepData.js';

export const loadSampleFromProject = async (sequencerEngine, sample, project, patternNumber) => {
    let json = await ipfs.getJson(project.newSequence);

    // first find the project's subSequence id and trackNumber
    let {subSequence, trackNumber} = getTrackNumber(json, sample.ipfsHash);

    console.log("loadSampleFromProject got sub=%s track=%s", subSequence, trackNumber);
    if (subSequence === -1 || trackNumber === -1) {
        // we couldnt find it
        return;
    }

    return loadPattern(sequencerEngine, json, subSequence, trackNumber, patternNumber);
};

const getTrackNumber = (data, sampleId) => {

    for (let subSequence of data.subSequences) {
        for (let trackNumber in subSequence.tracksData) {
            let track = subSequence.tracksData[trackNumber]
            if (track.type === "SAMPLER") {
                let sampleIds = Object.keys(track.samplers);
                if (sampleIds.indexOf(sampleId) > -1) {
                    // then its this one
                    return {
                        subSequence: subSequence.id,
                        trackNumber
                    };
                }
            } else if (track.type === "INSTRUMENT_RACK") {
                let tracks = subSequence.tracksData[trackNumber].tracks;
                for (let _track of tracks) {
                    let samplers = _track.track.instrument.samplers;
                    if (Object.keys(samplers).find(x => samplers[x].sampleId === sampleId)) {
                        return {
                            subSequence: subSequence.id,
                            trackNumber
                        };
                    }
                }
            }
        }
    }
    return {
        subSequenceId: -1,
        trackNumber: -1,
    };
};


const loadPattern = (sequencerEngine, data, subSequence, trackNumber, patternNumber) => {
    subSequence = data.subSequences.find(x => x.id === subSequence);
    let _track = subSequence.tracks[trackNumber];
    if (patternNumber === undefined) {
        patternNumber = 0;
        for (let p in _track) {
            // see if any of the steps are on
            let _pattern = _track[p];
            let size = _pattern.size;
            for (let i=0; i < size; i++) {
                var jsonStepBucket = _pattern[i];
                for (let pos in jsonStepBucket) {
                    if (jsonStepBucket[pos].on) {
                        patternNumber = parseInt(p);
                        break;
                    }
                }
            }
        }
    }
    let _pattern = _track[patternNumber];
    let track = sequencerEngine.getSelectedTrack();
    let pattern = track.patterns[track.currentPattern];

    let size = _pattern.size;
    pattern.changeLength(size, false);
    pattern.clear();

    for (var j=0; j < size; j++) {
        if (!(j in _pattern)) {
            continue;
        }
        
        var stepBucket = pattern.stepBuckets[j];
        var jsonStepBucket = _pattern[j];
        
        // fill the steps for this buckets using the json's data
        // Each step has several parameters, that need to be loaded
        // into a StepData object
        
        for (var key in jsonStepBucket) {
            var stepData = stepBucket.steps[key] || new StepData();
            stepData.track = track;
            stepData.stepNumber = j;
            stepData.simpleLoad(
                jsonStepBucket[key], track.effects, track, track.midiEffects.effects);
            stepBucket.steps[key] = stepData;
        }
    }
    
    pattern.loadStepBuckets(undefined, true);
    track.updateSteps();

    let _trackData = subSequence.tracksData[trackNumber];
    track.fromJson(_trackData);

    if (_trackData.type === "SAMPLER" &&
        track.getTrackType() === "SAMPLER") {
        let sampler = track.getSamplers()[0];
        for (let id in _trackData.samplers) {
            let _sampler = _trackData.samplers[id];
            let slices = _sampler.slices;
            sampler.slice(0, slices[0].startTime, slices[0].endTime);
            slices = slices.slice(1);
            for (let slice of slices) {
                sampler.newSlice(slice.startTime, slice.endTime);
            }
        }
    } else if (_trackData.type === "INSTRUMENT_RACK" &&
               track.getTrackType() === "SAMPLER") {
        // then we need to convert this track to a thing
    }

    // MIDI EFFECTS!! and EFFECTS
    let _midiEffects = subSequence.tracksMidiEffects[trackNumber];
    track.midiEffects.effects = [];
    track.midiEffects.fromJson(_midiEffects);

    return _track.length;
};
